import { render, staticRenderFns } from "./DiaGoosInfo.vue?vue&type=template&id=4bae415c"
import script from "./DiaGoosInfo.vue?vue&type=script&lang=js"
export * from "./DiaGoosInfo.vue?vue&type=script&lang=js"
import style0 from "./DiaGoosInfo.vue?vue&type=style&index=0&id=4bae415c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports